import {ERequestType} from "@gongt/ts-stl-library/request/request";
import {ApiResponse} from "@gongt/ts-stl-library/request/protocol";
import {UserQueryRequest} from "./user-query";

export const CheckPermissionUrl = `/check_permission`;
export const CheckPermissionMethod = ERequestType.TYPE_GET;

export interface CheckPermissionBody extends UserQueryRequest {
	permName: string;
	scope: string;
	project: string;
}

export interface CheckPermissionResponse extends ApiResponse {
	hasPermission: boolean;
	count: number;
	expireSeconds: number;
}
